module.exports = __webpack_public_path__ + "img/about-5.3c4773bb.png";